import styled from 'styled-components'
import { Box } from '@mui/material'

export const ContainerSearch = styled(Box)`
  padding: 2px 4px;
  display: flex;
  align-items: center;
  border: 1px solid lightgray;
  border-radius: 4px;
`
